export default {
      id: "at-sign-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#at-sign",
      toString: function () {
        return this.url;
      }
    }